import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface LoadingState {
  pendingRequestCount: number;
  global: boolean;
  pages: Record<string, boolean>;
  components: Record<string, boolean>;
  apiCalls: Record<string, boolean>;
}

const initialState: LoadingState = {
  pendingRequestCount: 0,
  global: false,
  pages: {},
  components: {},
  apiCalls: {},
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    incrementRequests(state) {
      state.pendingRequestCount += 1;
      state.global = true;
    },
    decrementRequests(state) {
      state.pendingRequestCount = Math.max(0, state.pendingRequestCount - 1);
      state.global = state.pendingRequestCount > 0;
    },
    startPageLoading(state, action: PayloadAction<string>) {
      state.pages[action.payload] = true;
    },
    stopPageLoading(state, action: PayloadAction<string>) {
      state.pages[action.payload] = false;
    },
    setComponentLoading(state, action: PayloadAction<{ id: string; loading: boolean }>) {
      state.components[action.payload.id] = action.payload.loading;
    },
    startApiCall(state, action: PayloadAction<string>) {
      state.apiCalls[action.payload] = true;
    },
    stopApiCall(state, action: PayloadAction<string>) {
      state.apiCalls[action.payload] = false;
    },
    resetLoading(state) {
      state.pendingRequestCount = 0;
      state.global = false;
      state.pages = {};
      state.components = {};
      state.apiCalls = {};
    },
  },
});

export const {
  incrementRequests,
  decrementRequests,
  startPageLoading,
  stopPageLoading,
  setComponentLoading,
  startApiCall,
  stopApiCall,
  resetLoading,
} = loadingSlice.actions;

export default loadingSlice.reducer;
